import axios from 'axios';
import React, { Component, useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import Dashboard from './Dashboard';

export default function CheckoutDetail() {
    const { id } = useParams();
    const [data, setData] = useState({});
    useEffect(() => {
        axios.get(`${process.env.REACT_APP_API_URL}checkoutForm/checkout-form-entries-by-id/${id}`, {
            headers: {
                Authorization: `Bearer ${localStorage.getItem("apEnergyAdminToken")}`
            }
        }).then((res) => {
            if (res && res.data && res.data.success) {
                setData(res.data.data);
            }
        }).catch((err) => {
            console.log(err);
        })
    }, []);
    return (
        <>
            <Dashboard>
            <div className='flex flex-col items-center justify-center mt-10 text-center'>
                {
                    Object.keys(data).length !== 0 ?
                        <>
                            <table className='w-[80%] border-2'>
                                <tr>
                                    <th className='border-2'>Date</th>
                                    <td className='border-2'>{new Date(data.submission_date || data.createdAt).toLocaleString() || ''}</td>
                                </tr>
                                <tr>
                                    <th className='border-2'>User</th>
                                    <td className='border-2'>{data.technician_name || ''}</td>
                                </tr>
                                <tr>
                                    <th className='border-2'>Meters Going To</th>
                                    <td className='border-2'>{data.customer_name || ''}</td>
                                </tr>
                                <tr>
                                    <th className='border-2'>City</th>
                                    <td className='border-2'>{data.city || ''}</td>
                                </tr>
                                <tr>
                                    <th className='border-2'>State</th>
                                    <td className='border-2'>{data.state || ''}</td>
                                </tr>
                                <tr>
                                    <th className='border-2'>Checkout Location</th>
                                    <td className='border-2'>{data.storage || ''}</td>
                                </tr>
                                <tr>
                                    <th className='border-2'>Number of Meters Scanned</th>
                                    <td className='border-2'>{data.scanned_barcodes && data.scanned_barcodes.length ? data.scanned_barcodes.length : 0}</td>
                                </tr>
                            </table>

                            {
                                data.scanned_barcodes && data.scanned_barcodes.length ?
                                    <>
                                        <h2 className='mt-10 mb-5 text-xl font-bold'>Scanned Barcodes</h2>
                                        <table className='w-[80%] border-2 mt-5 text-center'>
                                            <thead>
                                                <tr>
                                                    <th className='border-2'>#</th>
                                                    <th className='border-2'>AP Barcode No.</th>
                                                    <th className='border-2'>Meter Serial No.</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {
                                                    data.scanned_barcodes.map((item, idx) => (
                                                        <tr key={idx}>
                                                            <td className='border-2'>{idx + 1}</td>
                                                            <td className='border-2'>{item?.ap_inventory_barcode || 'N/A'}</td>
                                                            <td className='border-2'>{item?.ap_equipment_id_number || 'N/A'}</td> 
                                                        </tr>
                                                    ))
                                                }
                                            </tbody>
                                        </table>
                                    </>
                                    :
                                    <></>
                            }
                        </>
                        :
                        <>
                        </>
                }
            </div>
            </Dashboard>
        </>
    )
}

